import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { Branch, form_control } from "projects/sepidz-web-framework/src/lib/models";
import { DialogType } from "projects/sepidz-web-framework/src/lib/models/dialog.enum";
import { Dictionary } from "projects/sepidz-web-framework/src/lib/models/dictionary";
import { RowState } from "projects/sepidz-web-framework/src/lib/models/enums";
import { takeUntil } from "rxjs/operators";
import { CheckBrachAccessModel } from "src/app/gnr/data-center-process/chek-branch-access.model";
import { Zone, ZoneBranch } from "../model/zone.model";

@Component({
  selector: "ngx-zone",
  templateUrl: "./zone-form.component.html",
  styleUrls: ["./zone-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ZoneFormComponent extends BaseFormComponent<Zone> {
  activeTabTitle: string;
  erroremessage: string;
  haserror: boolean = false;
  DefaultValues: Dictionary = [];
  isAccessToAllBranches = true;
  Branches: form_control[];
  terminate: boolean;
  onPermissionDelete: boolean = false;
  deactivateSave: boolean = false;
  showBranch: boolean = false;
  rowIsEditing: boolean = false;

  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
    this.FillData();
  }

  async ngOnInit() {
    this.apiName = "Zone";
    this.label = this.translate("ClientApp.FrontOffice.Parties.Zone.Zone");
    super.ngOnInit();
    this.DefaultValues["ZoneId"] = 0;
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.Branches = undefined;
    this.DefaultValues = undefined;
  }

  setColumnAttribute(): void {
    super.setColumnAttribute();
    this.Branches = this.getDetailControlModels("Branches");
  }

  setdefault() {
    if (!this.model.Branches) this.model.Branches = [];

    if (!this.model.Paths) this.model.Paths = [];

    //اگر در مد ایجاد بودیم
    if (this.model && !(this.model.Id > 0)) this.model.IsActive = true;

    if (!this.accountService.authService.currentBranch) setTimeout(() => this.populateBranch(), 300);
    else this.populateBranch();

    if (!this.model.IsFreeDelivery) this.formGroup.controls["MinimumPurchaseForFreeShipping"].disabled;

    if (this.model.Id) this.setHeaderInfo();
  }

  setHeaderInfo(): void {
    this.model.Branches?.forEach((branch) => {
      if (branch.IsFreeDelivery && !branch.MinimumPurchaseForFreeShipping) {
        this.haserror = true;
        this.erroremessage = this.translate("ClientApp.FrontOffice.Parties.Zone.EnteringMinimumInvoiceTotalRequired");
        return !this.haserror;
      }
    });
    if (this.model.Branches?.length) {
      const defaultBranch = this.model.Branches.find((branch) => branch.IsDefault);
      if (typeof defaultBranch?.ShippingCost === "number") {
        this.setValue("ShippingCost", defaultBranch.ShippingCost);
        this.model.ShippingCost = defaultBranch.ShippingCost;
      }
      if (typeof defaultBranch?.CourierShippingCost === "number") {
        this.setValue("CourierShippingCost", defaultBranch.CourierShippingCost);
        this.model.CourierShippingCost = defaultBranch.CourierShippingCost;
      }
      if (typeof defaultBranch?.MinutesToDelivery === "number") {
        this.setValue("MinutesToDelivery", defaultBranch.MinutesToDelivery);
        this.model.MinutesToDelivery = defaultBranch.MinutesToDelivery;
      }
      if (typeof defaultBranch?.IsFreeDelivery === "boolean") {
        this.setValue("IsFreeDelivery", defaultBranch.IsFreeDelivery);
        this.model.IsFreeDelivery = defaultBranch.IsFreeDelivery;
        if (!defaultBranch?.IsFreeDelivery) {
          defaultBranch.MinimumPurchaseForFreeShipping = 0;
        }
      }
      if (typeof defaultBranch?.MinimumPurchaseForFreeShipping === "number") {
        this.setValue("MinimumPurchaseForFreeShipping", defaultBranch.MinimumPurchaseForFreeShipping);
        this.model.MinimumPurchaseForFreeShipping = defaultBranch.MinimumPurchaseForFreeShipping;
      }
    }
  }

  addControl() {
    if (this.formGroup && this.model.IsFreeDelivery) this.formGroup.controls["MinimumPurchaseForFreeShipping"].enable();
    this.cd.markForCheck();
  }

  shippingCostController(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (this.terminate) {
        this.sts.showDialog(
          this.translate("ClientApp.FrontOffice.Parties.Zone.PerformingThisOperationSubscribers"),
          this.translate("ClientApp.FrontOffice.Parties.Zone.SubscriberUpdate"),
          DialogType.confirm,
          (okCallback) => {
            resolve(true);
          },
          (cancelCallback: void) => {
            reject(false);
          }
        );
      } else reject(false);
    });
  }

  async save() {
    if (!this.formGroup.controls["ShippingCost"].value || this.formGroup.controls["ShippingCost"].dirty) {
      this.terminate = true;
      let accept = false;
      if (this.model.Id && this.formGroup.controls["ShippingCost"].value !== this.currentrow.ShippingCost) {
        await this.shippingCostController().then(
          (onfulfilled) => {
            accept = true;
          },
          (onrejected) => {
            accept = false;
          }
        );
      } else {
        accept = true;
      }
      if (!accept) {
        this.submitted = false;
        this.selectorService.submitted$.next(this.submitted);
        return;
      }
    }
    super.save();
  }
  populateBranch() {
    this.httpCommonService
      .getList("Branch")
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(async (data: Branch[]) => {
        let BranchList: Branch[] = data;
        BranchList = BranchList.filter((x) => (this.isMultiBranch ? !x.AccessToAllBranches : true));
        if (!this.model) this.model = <Zone>{};
        if (!this.model.Branches) this.model.Branches = [];
        BranchList?.forEach((br: Branch) => {
          const listBranch = this.model.Branches.find((x) => x.BranchId === br.Id);
          if (!listBranch) {
            let entity = <ZoneBranch>{};
            entity.BranchId = br.Id;
            entity.BranchTitle = br.Title;
            entity.IsActive = true;
            entity.IsFreeDelivery = false;
            entity.ShippingCost = 0;
            entity.CourierShippingCost = 0;
            entity.MinutesToDelivery = 0;
            entity.State = RowState.New;
            if (!this.model || !(this.model.Id > 0)) {
              //اگر در مد ایجاد بودیم
              entity.Selected = true;
            } else {
              entity.Selected = false;
            }
            this.model.Branches.push(entity);
          } else {
            listBranch.Selected = true;
          }
        });

        this.showBranch = true;
      });
  }

  afterSaveRow(entity: ZoneBranch): void {
    this.setHeaderInfo();
    this.cd.markForCheck();
  }

  beforupdate() {
    this.model.Branches = this.model.Branches?.filter((x) => x.Selected);
    if (this.model.Paths && this.model.Paths.length <= 0) this.model.Paths = null;
    if (this.model?.Branches && this.model?.Branches.length <= 0) {
      this.model.Branches = null;
    }
    this.model.Branches?.forEach((x) => {
      if (x && x.BranchId === this.accountService.authService.currentBranchId) {
        if (this.formGroup.controls["IsActive"].value != this.model.IsActive) x.IsActive = this.formGroup.controls["IsActive"].value ? true : false;
        if (this.formGroup.controls["ShippingCost"].value != this.model.ShippingCost) x.ShippingCost = this.formGroup.controls["ShippingCost"].value;
        if (this.formGroup.controls["CourierShippingCost"].value != this.model.CourierShippingCost)
          x.CourierShippingCost = this.formGroup.controls["CourierShippingCost"].value;
        if (this.formGroup.controls["MinutesToDelivery"].value != this.model.MinutesToDelivery)
          x.MinutesToDelivery = this.formGroup.controls["MinutesToDelivery"].value;
        if (this.formGroup.controls["IsFreeDelivery"].value != this.model.IsFreeDelivery)
          x.IsFreeDelivery = this.formGroup.controls["IsFreeDelivery"].value;
        if (!x.IsFreeDelivery) {
          x.MinimumPurchaseForFreeShipping = null;
        } else if (this.formGroup.controls["MinimumPurchaseForFreeShipping"].value != this.model.MinimumPurchaseForFreeShipping)
          x.MinimumPurchaseForFreeShipping = this.formGroup.controls["MinimumPurchaseForFreeShipping"].value;
        if (x.State === RowState.NoChange) x.State = RowState.Modify;
      } else if (x && !x.IsFreeDelivery) x.MinimumPurchaseForFreeShipping = null;
    });

    const { ShippingCost, CourierShippingCost, MinutesToDelivery, IsFreeDelivery, MinimumPurchaseForFreeShipping } = this.formGroup.getRawValue();
    let defaultBranch = this.model.Branches.find((x) => x.IsDefault);
    if (!defaultBranch && this.model.Branches.length === 1) {
      this.model.Branches[0].IsDefault = true;
      defaultBranch = this.model.Branches[0];
    }
    if (defaultBranch) {
      if (ShippingCost) defaultBranch.ShippingCost = ShippingCost;
      if (CourierShippingCost) defaultBranch.CourierShippingCost = CourierShippingCost;
      if (MinutesToDelivery) defaultBranch.MinutesToDelivery = MinutesToDelivery;
      if (typeof IsFreeDelivery === "boolean") defaultBranch.IsFreeDelivery = IsFreeDelivery;
      if (MinimumPurchaseForFreeShipping) defaultBranch.MinimumPurchaseForFreeShipping = MinimumPurchaseForFreeShipping;
      defaultBranch.State = RowState.Modify;
    }
  }

  isActveTab(title: string) {
    return this.activeTabTitle === title;
  }
  selectTab($event) {
    this.activeTabTitle = $event.tabTitle;
  }
  valueChange(event) {
    if (event == true && this.formGroup.controls["IsFreeDelivery"].value == true) {
      this.formGroup.controls["MinimumPurchaseForFreeShipping"].enable();
    } else if (event == false && this.formGroup.controls["IsFreeDelivery"].value == false) {
      this.formGroup.controls["MinimumPurchaseForFreeShipping"].setValue(null);
      this.formGroup.controls["MinimumPurchaseForFreeShipping"].disable();
    }
    if (this.formGroup) {
      if (this.formGroup.controls["IsFreeDelivery"].value) {
        this.formGroup.controls["MinimumPurchaseForFreeShipping"].disable();
        this.columns.find((x) => x.name == "MinimumPurchaseForFreeShipping").disabled = false;
      } else {
        this.formGroup.controls["MinimumPurchaseForFreeShipping"].enable();
        this.columns.find((x) => x.name == "MinimumPurchaseForFreeShipping").disabled = true;
      }
    }
    this.cd.markForCheck();
  }
  isValid() {
    this.erroremessage = undefined;
    this.haserror = false;
    if (
      this.formGroup.controls["IsFreeDelivery"].value == true &&
      (this.formGroup.controls["MinimumPurchaseForFreeShipping"].value == undefined ||
        this.formGroup.controls["MinimumPurchaseForFreeShipping"].value == null ||
        this.formGroup.controls["MinimumPurchaseForFreeShipping"].value == "" ||
        this.formGroup.controls["MinimumPurchaseForFreeShipping"].value < 0)
    ) {
      this.haserror = true;
      this.erroremessage = this.translate("ClientApp.FrontOffice.Parties.Zone.EnteringMinimumInvoiceTotalRequired");
    } else {
      this.haserror = false;
      this.erroremessage = "";
    }

    if (this.accountService.authService.currentInformation().RestaurantCallCenter && !this.model.Branches.find((x) => x.IsDefault)) {
      this.erroremessage = this.translate("ClientApp.FrontOffice.Parties.Zone.SelectLeastOneBranchDefault");
      this.haserror = true;
    }
    this.model.Branches?.some((x) => {
      if (!x.IsDefault && x.IsFreeDelivery && !x.MinimumPurchaseForFreeShipping) {
        this.haserror = true;
        this.erroremessage = this.translate("ClientApp.FrontOffice.Parties.Zone.EnteringMinimumInvoiceTotalRequired");
        return !this.haserror;
      }
    });
    return !this.haserror;
  }
  setMaxCode() {
    this.httpCommonService
      .getMaxCode(this.apiName)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((data) => {
        if (!this.model) this.model = <Zone>{};
        if (data) {
          this.model["Code"] = data as number;
        }
        this.setFormGroup(this.model);
      });
  }
  onDelete($event) {
    if (this.onPermissionDelete) {
      this.sts.showDialog(
        this.translate("ClientApp.FrontOffice.Parties.Zone.HasBranchCommunication"),
        this.translate("ClientApp.FrontOffice.Parties.Zone.Attention")
      );
    }
  }
  async FillData() {
    if (
      this.accountService.authService.currentInformation().BranchingLightEnabled ||
      this.accountService.authService.currentInformation().BranchingAdvancedEnabled
    ) {
      this.httpCommonService
        .getList("UserLocalSetting/GetValidationBranch" + "/Locations")
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((hbc: CheckBrachAccessModel) => {
          if (hbc.TransferKindCode != 3) {
            if ((hbc.TransferKindCode == 2 || hbc.TransferKindCode == 5) && hbc.HasCommunication == true && hbc.BranchCount == 1) {
              this.sts.showDialog(
                this.translate("ClientApp.FrontOffice.Parties.Zone.HasBranchCommunication"),
                this.translate("ClientApp.FrontOffice.Parties.Zone.Attention")
              );
              this.deactivateSave = true;
              return;
            } else {
              if ((hbc.TransferKindCode == 1 || hbc.TransferKindCode == 4) && hbc.BranchCount > 1) {
                this.sts.showDialog(
                  this.translate("ClientApp.FrontOffice.Parties.Zone.HasCallCenterCommunication"),
                  this.translate("ClientApp.FrontOffice.Parties.Zone.Attention")
                );
                this.deactivateSave = true;
                return;
              }
            }
          }
        });
      (error) => this.getFailedHelper(error);
    }
  }
}
